import { PartialStoryFn, StoryContext } from '@storybook/addons';
import { html } from 'lit-html';
import { ifDefined } from 'lit-html/directives/if-defined';
import { Radio } from '../radio';

export const meta = {
  argTypes: {
    alignment: { table: { disable: true } },
    checked: { table: { disable: true } },
    disabled: { table: { disable: true } },
    id: { table: { disable: true } },
    label: { table: { disable: true } },
    name: { table: { disable: true } },
    required: { table: { disable: true } },
    tooltip: { table: { disable: true } },
    value: { table: { disable: true } },
  },
  args: {
    alignment: '',
    checked: false,
    disabled: false,
    id: '',
    label: 'Radio label',
    name: 'radio-name',
    required: false,
    tooltip: '',
    value: 'radio-value',
  },
  decorators: [
    (story: PartialStoryFn, { args: { tooltip } }: StoryContext) =>
      html`
        <style type="text/css">
          #root,
          .docs-story {
            padding-top: ${tooltip ? '2rem' : ''};
        </style>
        ${story()}
      `,
  ],
  parameters: {
    controls: {
      hideNoControlsWarning: true,
      sort: 'requiredFirst',
    },
  },
  title: 'Components/Radio/',
};

interface Story {
  alignment: Radio['alignment'];
  checked: Radio['checked'];
  disabled: Radio['disabled'];
  id: string;
  label: string;
  name: Radio['name'];
  required: Radio['required'];
  tooltip: Radio['tooltip'];
  value: Radio['value'];
}

export const story = ({
  alignment,
  checked,
  disabled,
  id,
  label,
  name,
  required,
  tooltip,
  value,
}: Partial<Story>) => html`
  <abds-radio
    alignment="${ifDefined(alignment || undefined)}"
    checked="${ifDefined(checked || undefined)}"
    disabled="${ifDefined(disabled || undefined)}"
    id="${ifDefined(id || undefined)}"
    name="${ifDefined(name || undefined)}"
    required="${ifDefined(required || undefined)}"
    tooltip="${ifDefined(tooltip || undefined)}"
    value="${ifDefined(value || undefined)}"
  >
    ${label}
  </abds-radio>
`;

export default { meta, story };
